import * as d3 from 'd3-selection'
import InstantUpdateAnimation from './instant-update-animation'

// Returns an array of the serie ids in their current order
const serieOrder = function (selection) {
  return selection.data().map(serie => serie.id)
}

/*
 * Controls the animation
 */
class AnimationController {

  constructor (graph, options) {
    let serieOrder0 = options.previous.serieOrder
      , serieOrder1 = serieOrder(options.series.selection())

    // Create a flag to let the animations know if series changed (order, new serie, removed, etc)
    let seriesChanged = (!(serieOrder0.length == serieOrder1.length) ||
                         !serieOrder0.every((f, i) => f == serieOrder1[i]))

    this.graph = graph // This is the main graph function (i.e. line, bar, etc.)
    this.exitingSeries = options.exitingSeries // All series removed from this chart type
    this.series = options.series
    this.chart = options.chart
    this.scalers = options.scalers

    // We build an array of all possible animations for this graph type
    // Note: each animation that matches will be recreated for each object. This
    // will be improved in #45101 so we don't have to create animation objects
    // to determine if they are a match.
    this.animationOptions = {
      seriesChanged,
      plotId: options.plotId,
      scalers: options.scalers,
      exitingSeries: options.exitingSeries,
      series: options.series,
      totalDuration: options.duration,
      chart: options.chart,
      serieScale: options.serieScale,
      previous: options.previous
    }

    this.animations = graph.animations.map(Animation => {
      return new Animation(this.animationOptions)
    })

    this.animations.unshift(new InstantUpdateAnimation(this.animationOptions))
  }

  animate (container) {
    // For each of the series
    let self = this
      , animationData = {}

    if (this.graph.preAnimate) {
      // Used to configure the animations at a non-serie level. Called once, instead of
      // once per serie using animation.configure.

      // the preAnimate function on a graph will return an optional object of data
      // that is shared for all animations
      animationData = this.graph.preAnimate(this.chart, container.selection(), this.series, this.scalers, container.duration())

      this.graph._animationData = animationData
    }

    // Animate each serie on its own
    this.series.each(function (serie) {
      self._animateSerie(container, this, animationData)
    })

    // Animate the series that are leaving
    this.exitingSeries.each(function (serie) {
      self._animateSerie(container, this, animationData)
    })

    if (this.graph.postAnimate) {
      container.end().then(() => {
        // Pass the selection of the transition
        this.graph.postAnimate(this.chart, container.selection())
      }).catch(() => {
        // interrupted transition, ignore
      })
    }

  }

  _animateSerie (container, node, animationData) {
    let data = d3.select(node).datum() // serie data for the node
      , Animation = this._getAnimationClass(data)
      , animation = new Animation(this.animationOptions) // Build a new animation object for each serie
      , axis = data.axis || 'left'

    // console.log("Using animation ", animation)

    // Assign the shared animation data to the animation object
    Object.assign(animation, animationData)

    animation.configure(axis, data)
             .bindAndAnimate(container, node)
  }

  /*
   * Returns the animation class that should be used to run the animations.
   */
  _getAnimationClass (serie) {
    let animation = this.animations.find(animation => {
      return animation.match(serie)
    })

    if (!animation) {
      throw new Error('Unsure how to animate the nodes')
    }

    return animation.constructor
  }

}

export default AnimationController
